/**
 *
 * Asynchronously loads the component for ForgetPasswordModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ForgetPasswordModule = lazyLoad(
  () => import('./index'),
  module => module.ForgetPasswordModule,
);
